import * as tasksActions from './actions';


export { tasksActions };
export * from './action-types';
export { tasksReducer } from './reducer';
export { getTaskFilter, getVisibleTasks } from './selectors';
export { Task } from './task';



// WEBPACK FOOTER //
// ./src/core/tasks/index.js